<template>
  <div class="bottom_home">
    <!-- 底部内容 -->
    <div class="bottom_text" >
      <p >{{RecordNo.name}}：{{RecordNo.pvalue}} </p>
      <p >{{technicalsupport.name}}：{{technicalsupport.pvalue}} </p>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      buttomdata:[],
      RecordNo:'',
      technicalsupport:''


    }
  },
  mounted(){
    this.getinfo()
  },
  methods:{
    // 获取接口数据
    async getinfo(){
      let res = await this.api.getbuttom('params_list')
      this.buttomdata = res.data.data
      this.buttomdata.forEach(item=>{
        if(item.cite=='record.number'){
            this.RecordNo = item
        }
        if(item.cite=='technical.support'){
            this.technicalsupport = item
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom_home{
  width: 100%;
}
.bottom_text{
  margin: 0 auto;
  width: 1200px;
  border-top: 1px solid #cccccc;
  display: flex;
  justify-content: space-around;
  margin-top: 30px;
  padding-top: 45px;
  box-sizing: border-box;
}
</style>